import { useTranslation } from 'react-i18next';
import ActionButton from '../common/ActionButton';

export default function ContactSection() {
  const { t }: { t: (key: string) => string } = useTranslation();

  return (
    <section
      id="contact"
      className="py-[100px] flex items-center bg-cover bg-center bg-no-repeat bg-contact-mobile md:bg-contact"
    >
      <div className="w-full max-w-[1280px] mx-auto px-6 text-center md:text-left">
        <h2 className="text-2xl md:text-4xl font-bold mb-6 text-white">
          <div className="mb-4 sm:mb-2">
            {t('Contact.title')}
            <div className="block sm:hidden" />
            {t('Contact.title2')}
          </div>
          <div>
            {t('Contact.subtitle')}
            <div className="block sm:hidden" />
            {t('Contact.subtitle2')}
          </div>
        </h2>
        <div className="flex justify-center md:justify-start">
          <a
            href={`mailto:consult@iacloud.kr?subject=${t('Contact.emailSubject')}&body=${t('Contact.emailBody')}`}
          >
            <ActionButton label={t('Contact.emailButton')} type="orange" />
          </a>
        </div>
      </div>
    </section>
  );
}
